import { render, staticRenderFns } from "./TodayIssueList.vue?vue&type=template&id=7447009a"
import script from "./TodayIssueList.vue?vue&type=script&lang=js"
export * from "./TodayIssueList.vue?vue&type=script&lang=js"
import style0 from "./TodayIssueList.vue?vue&type=style&index=0&id=7447009a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports